import { Directive, ElementRef, Input, HostListener } from '@angular/core';
import { MatLegacyTooltip as MatTooltip } from '@angular/material/legacy-tooltip';

@Directive({
	selector: '[appTruncateTooltip]',
	providers: [MatTooltip],
})
export class TruncateTooltipDirective {
	@Input() appTruncateTooltip: string = '';

	constructor(
		private el: ElementRef,
		private matTooltip: MatTooltip
	) {}

	@HostListener('mouseenter') onMouseEnter() {
		this.showFullTextTooltip();
	}

	@HostListener('mouseleave') onMouseLeave() {
		this.hideTooltip();
	}

	private showFullTextTooltip() {
		const element = this.el.nativeElement;
		const isOverflowing = element.scrollWidth > element.clientWidth;
		if (isOverflowing && this.matTooltip) {
			this.matTooltip.message = this.appTruncateTooltip;
			this.matTooltip.tooltipClass = 'cc_mat_tooltip';
			this.matTooltip.show();
		}
	}

	private hideTooltip() {
		this.matTooltip.hide();
	}
}
